import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { getContainingView } from '@jbrowse/core/util';
import { observer } from 'mobx-react';
import { ContentBlock, ElidedBlock, InterRegionPaddingBlock, } from '@jbrowse/core/util/blockTypes';
import { ContentBlock as ContentBlockComponent, ElidedBlock as ElidedBlockComponent, InterRegionPaddingBlock as InterRegionPaddingBlockComponent, } from './Block';
const useStyles = makeStyles()({
    linearBlocks: {
        whiteSpace: 'nowrap',
        textAlign: 'left',
        position: 'absolute',
        minHeight: '100%',
        display: 'flex',
    },
    heightOverflowed: {
        position: 'absolute',
        color: 'rgb(77,77,77)',
        borderBottom: '2px solid rgb(77,77,77)',
        textShadow: 'white 0px 0px 1px',
        whiteSpace: 'nowrap',
        width: '100%',
        fontWeight: 'bold',
        textAlign: 'center',
        zIndex: 2000,
        boxSizing: 'border-box',
    },
});
const RenderedBlocks = observer(({ model }) => {
    const { classes } = useStyles();
    const { blockDefinitions, blockState } = model;
    return (React.createElement(React.Fragment, null, blockDefinitions.map(block => {
        if (block instanceof ContentBlock) {
            const state = blockState.get(block.key);
            return (React.createElement(ContentBlockComponent, { block: block, key: `${model.id}-${block.key}` },
                state && state.ReactComponent ? (React.createElement(state.ReactComponent, { model: state })) : null,
                state && state.maxHeightReached ? (React.createElement("div", { className: classes.heightOverflowed, style: {
                        top: state.layout.getTotalHeight() - 16,
                        pointerEvents: 'none',
                        height: 16,
                    } }, "Max height reached")) : null));
        }
        if (block instanceof ElidedBlock) {
            return (React.createElement(ElidedBlockComponent, { key: `${model.id}-${block.key}`, width: block.widthPx }));
        }
        if (block instanceof InterRegionPaddingBlock) {
            return (React.createElement(InterRegionPaddingBlockComponent, { key: block.key, width: block.widthPx, style: { background: 'none' }, boundary: block.variant === 'boundary' }));
        }
        throw new Error(`invalid block type ${typeof block}`);
    })));
});
function LinearBlocks({ model }) {
    const { classes } = useStyles();
    const { blockDefinitions } = model;
    const viewModel = getContainingView(model);
    return (React.createElement("div", { "data-testid": "Blockset", className: classes.linearBlocks, style: {
            left: blockDefinitions.offsetPx - viewModel.offsetPx,
        } },
        React.createElement(RenderedBlocks, { model: model })));
}
export { RenderedBlocks, useStyles };
export default observer(LinearBlocks);
//# sourceMappingURL=LinearBlocks.js.map